const getNonHLNumbersLookup = function (state) {
  const lookupTable = {}
  const { phoneNumbers, locationTwilio } = state
  const filteredNumbers = phoneNumbers.filter(number => {
    return !Object.keys(locationTwilio?.numbers ?? {})?.includes(number.phone_number)
  })


  for (let index = 0; index < filteredNumbers?.length; ++index) {
    const item = filteredNumbers[index]
    const id = item?.phone_number
    lookupTable[id] = item
  }

  return lookupTable
}

export default getNonHLNumbersLookup
